import { TeamManagementWrapper } from "../../components";

export default function TeamManagementPage() {
  return (
    <>
      <TeamManagementWrapper />
    </>
  );
}
